import type { Resource } from '../../';
export const language_en: Resource = {"default":"English"};
